<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="page-title">
        <h2>{{ $t('farm.farms') }}</h2>
        <v-spacer></v-spacer>

        <v-btn color="primary" dark @click="$router.push({ name: 'FarmRegistartion' })">
          {{ $t('farm.registerAfarm') }}
        </v-btn>
      </div>

      <v-card elevation="0" class="px-5">
        <v-card-text>
          <v-data-table 
            :headers="tableHeaders" 
            :items="items" 
            item-key="farmNumber"
            :items-per-page="tableOptions.itemsPerPage" 
            :loading="loading" 
            loading-text="Loading Farms... Please wait"
            :footer-props="{
              'items-per-page-options': itemsPerPageOptions,
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Farms per page',
            }" 
            :options.sync="tableOptions"
            :server-items-length="totalfarms"
            hide-default-footer 
            :header-props="{
              'sort-icon': 'mdi-unfold-more-horizontal'
            }"
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field prepend-inner-icon="mdi-magnify" outlined height="5px" :placeholder="$t('farm.searchState')"
                  dense v-model="search" @click:append="searchFarms" @input="resetSearchOnEmpty"
                  class="shrink"></v-text-field>
                
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} of {{ totalfarms }}
                </div>
                <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)">
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)">
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                      <v-icon dark> mdi-cog-outline </v-icon>
                    </v-btn>
                  </template>

                  <v-card width="600">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{ $t('farm.customization') }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider></v-divider>
                      <div class="pl-3 pt-2 font-weight-normal">
                        {{ $t('farm.recordsPerpage') }}
                      </div>
                      <v-list-item>
                        <v-list-item-content>
                          <v-slider v-model="itemsPerPageSlider" :tick-labels="itemsPerPageOptions" :max="3" step="1"
                            ticks="always" tick-size="4"></v-slider>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-n3"></v-divider>
                    </v-list>
                    <v-card-text>
                      <v-container fluid>
                        <v-row>
                          <v-col class="mt-n9" cols="6" v-for="header in headers" :key="header.value">
                            <v-checkbox v-model="selectedHeaders" :label="header.text" color="primary" v-if="header.text != ''"
                              :value="header.text" hide-details :disabled="
                                header.value == 'farmNumber' || header.value == 'owner' || header.value == 'name'
                              "></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-layout justify-center>
                      <v-card-actions class="mb-5">
                        <v-spacer></v-spacer>

                        <v-btn outlined color="primary" @click="resetDefaut" width="fit-content">
                          {{ $t('farm.restoreDefault') }}
                        </v-btn>
                        <v-btn color="primary" @click="resetTableStructure" width="190">
                          {{ $t('farm.apply') }}
                        </v-btn>
                      </v-card-actions>
                    </v-layout>
                  </v-card>
                </v-menu>
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear color="primary" :height="8" indeterminate></v-progress-linear>
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id" 
                  style="position: relative; width: 0; height: 0">
                  <!-- <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                      v-on:click.stop=""
                    />
                  </td> -->
                  <template v-for="h in tableHeaders">
                    <td :key="h.value" v-if="h.value == 'farmNumber'">
                      <router-link :to="{name: 'SingleFarm', params: { id: item.farmNumber }}">{{  item.farmNumber }}</router-link>
                    </td>
                    <td :key="h.value" v-else-if="h.value == 'owner'">
                      {{ item[h.value] && item[h.value].name ? item[h.value].name : item.ownerId }}
                    </td>
                    <td :key="h.value" v-else-if="h.value == 'name'" style="max-width: 150px;">
                      {{ item[h.value] }}
                    </td>
                    <td :key="h.value" v-else-if="h.value == 'actions'" style="max-width: 150px;">
                      <v-btn class="text-capitalize elevation-0" color="primary" text  @click.prevent="assignUsers(item)">Assign Users</v-btn>
                    </td>
                    <td :key="h.value" v-else>
                      {{ item[h.value] }}
                    </td>
                  </template>
                  <div style="position: absolute; right: 10px; top: 4px" v-if="item === selectedItem">
                  </div>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="600"
        v-model="assignUsersPopup"
        v-if="assignUsersPopup"
      >
          <v-card class="pb-5">
            <v-toolbar
              color="secondary"
              dark
              flat
            >Assign Users
          </v-toolbar>
            <v-card-text class="pt-5">
              <v-row>
                <v-col cols="12">
                  <div class="subtitle">{{$t('Select Users')}}</div>
                  <UserDropdown
                    v-model="usersToAssign"
                    :farm="currentFarm"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn
                color="primary"
                outlined
                @click="assignUsersToFarmClose"
              >Cancel</v-btn>
              <v-btn
                color="primary"
                @click="assignUsersToFarm"
                class="px-5"
              >Assign</v-btn>
            </v-card-actions>
          </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import FarmService from "@/_services/farmService";
import UserDropdown from "@/components/UserDropdownMulti.vue";

export default {
  components: {
    breadcrumb: Breadcrumb,
    UserDropdown
  },
  watch: {
    tableOptions: {
      handler() {
        this.getfarm();
      },
      deep: true,
    },
  },
  async mounted() {
    document.title = this.$t('farm.farms');
    this.selectedHeaders = this.allSelectedHeaders;
    this.tableHeaders = this.headers;
  },
  created() {
    if (this.checkBreakPoints) this.tabletGetfarm();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  methods: {
    assignUsers(farm) {
      this.currentFarm = farm;
      this.assignUsersPopup = true;
    },
    assignUsersToFarm() {
      this.startLoading()
      // console.log('farm', this.currentFarm, this.usersToAssign)
      if(this.usersToAssign.length){
        this.usersToAssign.forEach((x,i)=>{
          x=x.split(" ")[1].replace("(","").replace(")","");
          this.usersToAssign[i]=x;
        })
      }
      FarmService.assingUsers(this.currentFarm.id, this.usersToAssign)
      .then((res) => {
        console.log(res)
      })
      .catch(e => {
        console.log(e)
      })
      .finally( () => {
        this.stopLoading()
        this.assignUsersToFarmClose()
        this.getfarm()
      })
    },
    assignUsersToFarmClose() {
      this.currentFarm = null;
      this.usersToAssign = [];
      this.assignUsersPopup = false;

    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    searchFarms() {
      if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.tabletGetfarm();
      } else {
        this.tableOptions.page = 1;
        this.getfarm();
      }
    },
    resetSearchOnEmpty() {
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.tabletGetfarm();
      } else {
        this.tableOptions.page = 1;
        this.getfarm();
      }
    },
    getfarm() {
      this.loading = true;
      FarmService.getfarms(this.tableOptions, this.search)
        .then((res) => {
          if (res.success) {
            this.items = res.data.rows;
            this.items?.length && this.items.forEach(x=>{
             x.Assignees?.length && x.Assignees.forEach(y=>{
                y.name=y.user && y.user.name?(y.user.name):null
                delete y.user;
              })
            })
            // console.log(this.items,"farm items");
            this.currentrows = res.data.numRows;
            this.totalfarms = res.data.totalRows;

            if (this.totalfarms < 1) {
              this.oldSelected = this.selectedHeaders;
              this.selectedHeaders = this.noRecordHeader;
            } else {
              if (this.oldSelected.length > 1)
                this.selectedHeaders = this.oldSelected;
              else {
                this.selectedHeaders = this.allSelectedHeaders;
                this.oldSelected = [];
              }
            }
            this.resetTableStructure();


            this.pageCount = Math.ceil(
              this.totalfarms / this.tableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalfarms / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage - res.data.numRows);
            console.log(this.totalfarms);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    tabletGetfarm() {
      this.loading = true;
      FarmService.getfarms(this.tabletTableOptions, this.search)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.items = res.data.rows;
            this.currentrows = res.data.numRows;
            this.totalfarms = res.data.totalRows;
            this.pageCount = Math.ceil(
              this.totalfarms / this.tabletTableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalfarms / this.tabletTableOptions.itemsPerPage
            );
            this.from =
              (this.tabletTableOptions.page - 1) *
              this.tabletTableOptions.itemsPerPage +
              1;
            this.to =
              this.tabletTableOptions.page *
              this.tabletTableOptions.itemsPerPage -
              (this.tabletTableOptions.itemsPerPage - res.data.numRows);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    goToFarm(frmNum) {
      this.$router.push({ name: "SingleFarm", params: { id: frmNum } });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.getfarm();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.tabletGetfarm();
    },
    resetDefaut() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
    },
    resetTableStructure() {
      this.startLoading();
      this.tableHeaders = this.headers.filter((header) =>
        this.selectedHeaders.includes(header.text)
      );
      this.tableOptions.itemsPerPage = this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.tabletTableOptions.itemsPerPage = this.itemsPerPageOptions[this.itemsPerPageSlider];
      this.menu = false;
      // this.getfarm();
      this.stopLoading();
    },
  },
  data() {
    return {
      currentFarm: null,
      assignUsersPopup: false,
      usersToAssign: [],
      menu: false,
      itemsPerPageSlider: 0,
      itemsPerPageOptions: [10, 25, 50, 100],

      to: "",
      from: "",
      totalPages: "",
      search: "",
      selected: [],
      items: [],
      totalfarms: 1,
      selectedItem: false,
      loading: false,
      length: 0,
      pageCount: 1,
      tableOptions: {},
      tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
      loadingText: "Loading... Please wait",
      breadcrumbs: [
        {
          text: this.$t('dashboard'),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t('farm.farms'),
          disabled: true,
          to: { name: "My farm" },
        },
      ],
      singleSelect: false,
      headers: [
        {
          text: this.$t('farm.farmID'),
          align: "start",
          value: "farmNumber",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t('farm.farmOwner'),
          value: "owner",
          class: "black--text",
          sortable: true,
        },
        { text: this.$t('farm.farmType'), value: "farmType", class: "black--text", sortable: true, },
        {
          text: this.$t('farm.cooperativeID'),
          value: "cooperativeID",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t('farm.govtRegistry'),
          value: "govRegistrationNo",
          class: "black--text",
          sortable: true,
        },
        {
          text: this.$t('farm.contractMating'),
          value: "contractMating",
          class: "black--text",
          sortable: true,
        },
        {
          text: '',
          value: "actions",
          class: "black--text",
          sortable: false,
          width: '250px'
        },
       
      ],
      tableHeaders: [],

      selectedHeaders: [],
      oldSelected: [],
      noRecordHeader: [
        this.$t('farm.farmOwner'),
        this.$t('farm.farmName'),
        this.$t('farm.farmType'),
        this.$t('farm.contractMating'),
        this.$t('farm.govtRegistry'),
        this.$t('farm.cooperativeID'),
      ],
      allSelectedHeaders: [
        this.$t('farm.farmID'),
        this.$t('farm.farmName'),
        this.$t('farm.farmOwner'),
        this.$t('farm.farmType'),
        this.$t('farm.contractMating'),
        this.$t('farm.govtRegistry'),
        this.$t('farm.cooperativeID'),
        this.$t(''),
      ],

      // users: [],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header th {
  white-space: nowrap;
}

::v-deep .v-data-table-header__icon {
  display: inline-block;
  opacity: 100 !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

::v-deep .v-data-table-header {
  background: $secondary2-color;
}

::v-deep .v-data-table-header span {
  // text-transform: uppercase !important;
  color: black;
}

::v-deep .v-data-table-header th {
  white-space: nowrap;
}

.table-header {
  background: $secondary2-color;
}

.table-header-span {
  text-transform: uppercase !important;
  color: black !important;
}
</style>